import { render } from "./CarouselGallerySlide.vue?vue&type=template&id=19b12ad1&scoped=true"
import script from "./CarouselGallerySlide.vue?vue&type=script&lang=js"
export * from "./CarouselGallerySlide.vue?vue&type=script&lang=js"

import "./CarouselGallerySlide.vue?vue&type=style&index=0&id=19b12ad1&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b12ad1"]])

export default __exports__